module.exports = __webpack_public_path__ + "static/cp-632a9f5219e1ee149f26b00eabe45eca.jpg";